import { render, staticRenderFns } from "./addAPhoneMenu.vue?vue&type=template&id=29ddd7dc"
import script from "./addAPhoneMenu.vue?vue&type=script&lang=js"
export * from "./addAPhoneMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports